(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // Move buy buttons after specs on product page
  document.addEventListener('DOMContentLoaded', function() {
    const productInfo = document.querySelector('.product-information');
    if (productInfo) {
      const buyButtons = productInfo.querySelector('.buy-buttons-block');
      const specsContainer = productInfo.querySelector('.product-detail-inner--specs');

      if (buyButtons && specsContainer) {
        // Move buy buttons after specs
        specsContainer.after(buyButtons);
      }

      // Add expandable functionality to product description
      const toggleBtn = productInfo.querySelector('.description-toggle-btn');
      const textBlocks = productInfo.querySelectorAll('.product-detail-item--blocks .text-block.rte');
      let descriptionBlock = null;

      // Find the description block that needs truncation
      textBlocks.forEach(function(block) {
        if (block.classList.contains('description-processed')) return;
        block.classList.add('description-processed');

        // Temporarily remove max-height to measure true height
        const originalMaxHeight = block.style.maxHeight;
        block.style.maxHeight = 'none';
        const fullHeight = block.scrollHeight;
        block.style.maxHeight = originalMaxHeight;

        // Check if this block has enough content to need truncation (> 70px)
        if (fullHeight > 70) {
          descriptionBlock = block;
        } else {
          // Short content - remove truncation
          block.classList.add('description-no-truncate');
        }
      });

      // If we found a description that needs truncation, set up the toggle
      if (descriptionBlock && toggleBtn) {
        // Move button right after the description block
        descriptionBlock.parentNode.insertBefore(toggleBtn, descriptionBlock.nextSibling);
        toggleBtn.style.display = '';

        // Toggle functionality
        toggleBtn.addEventListener('click', function() {
          const isExpanded = descriptionBlock.classList.contains('description-expanded');
          if (isExpanded) {
            descriptionBlock.classList.remove('description-expanded');
            toggleBtn.classList.remove('expanded');
            toggleBtn.querySelector('.toggle-text').textContent = '... Read more';
          } else {
            descriptionBlock.classList.add('description-expanded');
            toggleBtn.classList.add('expanded');
            toggleBtn.querySelector('.toggle-text').textContent = 'Show less';
          }
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Buy Now button functionality
  document.addEventListener('DOMContentLoaded', function() {
    const buyNowButtons = document.querySelectorAll('[data-buy-now]');

    buyNowButtons.forEach(function(button) {
      button.addEventListener('click', async function(e) {
        e.preventDefault();

        // Find the parent form to get the variant ID
        const form = button.closest('form');
        if (!form) return;

        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;

        const variantId = variantInput.value;
        const textSpan = button.querySelector('.buy-now-text');
        const loadingSpan = button.querySelector('.buy-now-loading');

        // Show loading state
        button.disabled = true;
        if (textSpan) textSpan.style.display = 'none';
        if (loadingSpan) loadingSpan.style.display = 'inline';

        try {
          // Add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (response.ok) {
            // Redirect to checkout
            window.location.href = '/checkout';
          } else {
            const error = await response.json();
            alert(error.description || 'Could not add to cart. Please try again.');
            // Reset button state
            button.disabled = false;
            if (textSpan) textSpan.style.display = 'inline';
            if (loadingSpan) loadingSpan.style.display = 'none';
          }
        } catch (err) {
          alert('Something went wrong. Please try again.');
          // Reset button state
          button.disabled = false;
          if (textSpan) textSpan.style.display = 'inline';
          if (loadingSpan) loadingSpan.style.display = 'none';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cashback-example"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(n) {
      return '$' + (n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    // Total = sum of each line's data-cashback, scoped per card so multiple instances don't cross-add.
    function sumCard(root) {
      var total = 0;
      root.querySelectorAll('[data-cashback]').forEach(function (el) {
        var v = parseFloat(el.getAttribute('data-cashback'));
        if (!isNaN(v)) total += v;
      });
      var out = root.querySelector('[data-total]');
      if (out) out.textContent = money(total);
    }
    function run() {
      document.querySelectorAll('.cbx').forEach(sumCard);
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    // Re-sum when the theme editor adds/edits a line.
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    class PchCountdown extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      this.nums = this.querySelectorAll('.countdown-unit__num');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
    tick() {
      let r = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (r <= 0) {
        this.expire();
        return;
      }
      const d = Math.floor(r / 86400); r %= 86400;
      const h = Math.floor(r / 3600); r %= 3600;
      const m = Math.floor(r / 60);
      const s = r % 60;
      const vals = [d, h, m, s];
      this.nums.forEach((el, i) => { if (vals[i] !== undefined) el.textContent = vals[i]; });
    }
    expire() {
      if (this.timer) clearInterval(this.timer);
      const msg = this.querySelector('.countdown-expired');
      if (msg) {
        const live = this.querySelector('.countdown-live');
        if (live) live.hidden = true;
        msg.hidden = false;
      } else if (this.hasAttribute('data-hide-expired')) {
        this.style.display = 'none';
      }
    }
  }
  if (!customElements.get('pch-countdown')) customElements.define('pch-countdown', PchCountdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["entry-options"] && !Shopify.designMode) return;
  try {
    class EntryOptionsToggle extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-tab]');
      this.tabContent = this.querySelectorAll('[data-tab-content]');
      this.switchTab(this.dataset.defaultTab || 'monthly');
      this.classList.add('eo--ready');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.switchTab(btn.dataset.tab));
      });

      this.handleHash = this.handleHash.bind(this);
      this.handleHash();
      window.addEventListener('hashchange', this.handleHash);

      this.initCarousels();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.handleHash);
    }

    switchTab(tab) {
      this.buttons.forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.tab === tab ? 'true' : 'false');
      });
      this.tabContent.forEach((el) => {
        el.hidden = el.dataset.tabContent !== tab;
      });
    }

    handleHash() {
      const hash = window.location.hash;
      if (hash === '#Memberships' || hash === '#RewardPacks') {
        this.switchTab(hash === '#Memberships' ? 'monthly' : 'onetime');
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    initCarousels() {
      this.querySelectorAll('.entry-options__nav').forEach((nav) => {
        const grid = this.querySelector('[data-cards="' + nav.dataset.navFor + '"]');
        if (!grid) return;
        const prev = nav.querySelector('[data-dir="-1"]');
        const next = nav.querySelector('[data-dir="1"]');

        const step = () => {
          const card = grid.querySelector('.offer-card');
          if (!card) return 0;
          const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
          return card.offsetWidth + gap;
        };
        const update = () => {
          const max = grid.scrollWidth - grid.clientWidth - 1;
          prev.disabled = grid.scrollLeft <= 0;
          next.disabled = grid.scrollLeft >= max;
        };
        const go = (dir) => {
          const size = step();
          if (!size) return;
          const max = grid.scrollWidth - grid.clientWidth;
          const target = Math.max(0, Math.min(max, (Math.round(grid.scrollLeft / size) + dir) * size));
          grid.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(() => {
            if (Math.abs(grid.scrollLeft - target) > 4) grid.scrollLeft = target;
            update();
          }, 300);
          setTimeout(update, 700);
        };

        prev.addEventListener('click', () => go(-1));
        next.addEventListener('click', () => go(1));
        grid.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        if (window.ResizeObserver) new ResizeObserver(update).observe(grid);
        update();
      });
    }
  }
  if (!customElements.get('entry-options-toggle')) {
    customElements.define('entry-options-toggle', EntryOptionsToggle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["giveaway"] && !Shopify.designMode) return;
  try {
    class GiveawayCard extends HTMLElement {
    connectedCallback() {
      var main = this.querySelector('[data-main-img]');
      var thumbs = this.querySelectorAll('[data-thumb]');
      if (main && thumbs.length) {
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var full = thumb.dataset.full;
            if (!full || main.getAttribute('src') === full) return;
            // Main image ships with a srcset; clear it so the explicit full-size src wins.
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = full;
            thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
            thumb.setAttribute('aria-current', 'true');
          });
        });
      }
      var toggle = this.querySelector('[data-details-toggle]');
      var panel = this.querySelector('.giveaway__details-panel');
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      }
    }
  }
  if (!customElements.get('giveaway-card')) {
    customElements.define('giveaway-card', GiveawayCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["homepage-shop"] && !Shopify.designMode) return;
  try {
    class ShopCarousel extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.hp-shop__grid');
      const nav = this.querySelector('.hp-shop__nav');
      if (!this.grid || !nav) return;
      this.prev = nav.querySelector('.hp-shop__nav-btn--prev');
      this.next = nav.querySelector('.hp-shop__nav-btn--next');
      this.update = this.update.bind(this);

      const motion = () => (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
      if (this.prev) this.prev.addEventListener('click', () => this.grid.scrollBy({ left: -this.step(), behavior: motion() }));
      if (this.next) this.next.addEventListener('click', () => this.grid.scrollBy({ left: this.step(), behavior: motion() }));
      this.grid.addEventListener('scroll', () => window.requestAnimationFrame(this.update), { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    step() {
      const card = this.grid.querySelector('.hp-shop__card');
      if (!card) return this.grid.clientWidth;
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 18;
      return card.getBoundingClientRect().width + gap;
    }
    update() {
      const max = this.grid.scrollWidth - this.grid.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.grid.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.grid.scrollLeft >= max;
    }
  }
  if (!customElements.get('shop-carousel')) {
    customElements.define('shop-carousel', ShopCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["membership-compare"] && !Shopify.designMode) return;
  try {
    class CompareCarousel extends HTMLElement {
    connectedCallback() {
      // Keep every card's value rows in lock-step with the description labels: a blank
      // trailing row label (e.g. unused rows 8–9) is dropped from the desc column, so trim
      // the matching value cells from each card too — otherwise the cards run taller and
      // the rows stop lining up.
      const descRows = this.querySelectorAll('.compare__desc-row').length;
      if (descRows) {
        this.querySelectorAll('.compare__values').forEach((col) => {
          col.querySelectorAll('.compare__value').forEach((cell, i) => { if (i >= descRows) cell.remove(); });
        });
      }

      this.grid = this.querySelector('.compare__table');
      this.nav = this.querySelector('.compare__nav');
      if (!this.grid || !this.nav) return;
      this.prev = this.nav.querySelector('[data-dir="-1"]');
      this.next = this.nav.querySelector('[data-dir="1"]');

      const step = () => {
        const card = this.grid.querySelector('.compare-card');
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        return card.offsetWidth + gap;
      };
      const update = () => {
        const max = this.grid.scrollWidth - this.grid.clientWidth - 1;
        this.prev.disabled = this.grid.scrollLeft <= 0;
        this.next.disabled = this.grid.scrollLeft >= max;
      };
      const go = (dir) => {
        const size = step();
        if (!size) return;
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        const target = Math.max(0, Math.min(max, (Math.round(this.grid.scrollLeft / size) + dir) * size));
        this.grid.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(update, 400);
      };

      this.prev.addEventListener('click', () => go(-1));
      this.next.addEventListener('click', () => go(1));
      this.grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(this.grid);
      update();
    }
  }
  if (!customElements.get('compare-carousel')) customElements.define('compare-carousel', CompareCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pch-product-carousel"] && !Shopify.designMode) return;
  try {
    // One controller per `.pch-carousel__group`: drives its track and shows/hides arrows based on
  // whether the track actually overflows (desktop grid or few cards = none; mobile/overflow = arrows).
  class PchCarouselGroup {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-cards]');
      const nav = root.querySelector('[data-nav]');
      this.prevButton = nav && nav.querySelector('[data-dir="-1"]');
      this.nextButton = nav && nav.querySelector('[data-dir="1"]');
      this.update = this.update.bind(this);
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCards(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCards(1));
      if (this.track) {
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
      }
      this.update();
    }

    cardStep() {
      const card = this.track && this.track.firstElementChild;
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    update() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.root.classList.toggle('pch-carousel__group--scrollable', maxScroll > 0);
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }

    scrollByCards(direction) {
      const step = this.cardStep();
      if (!step) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const target = Math.max(0, Math.min(maxScroll, (Math.round(this.track.scrollLeft / step) + direction) * step));
      this.track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(this.update, 350);
    }
  }

  class PchProductCarousel extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.pch-carousel__group')).map((group) => new PchCarouselGroup(group));
      this.onResize = () => this.groups.forEach((group) => group.update());
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
  }
  if (!customElements.get('pch-product-carousel')) {
    customElements.define('pch-product-carousel', PchProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    // Self-contained clone of the PCH carousel controller (see blocks/pch-product-carousel.liquid),
  // under unique names so the two blocks can coexist on one page without a duplicate class/element
  // declaration. Drives arrow scrolling and shows the arrows only when the track actually overflows.
  class RecsCarouselGroup {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-cards]');
      const nav = root.querySelector('[data-nav]');
      this.prevButton = nav && nav.querySelector('[data-dir="-1"]');
      this.nextButton = nav && nav.querySelector('[data-dir="1"]');
      this.update = this.update.bind(this);
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCards(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCards(1));
      if (this.track) {
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
      }
      this.update();
    }

    cardStep() {
      const card = this.track && this.track.firstElementChild;
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    update() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.root.classList.toggle('pch-carousel__group--scrollable', maxScroll > 0);
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }

    scrollByCards(direction) {
      const step = this.cardStep();
      if (!step) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const target = Math.max(0, Math.min(maxScroll, (Math.round(this.track.scrollLeft / step) + direction) * step));
      this.track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(this.update, 350);
    }
  }

  class PchRecsCarousel extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.pch-carousel__group')).map((group) => new RecsCarouselGroup(group));
      this.onResize = () => this.groups.forEach((group) => group.update());
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
  }
  if (!customElements.get('pch-recs-carousel')) {
    customElements.define('pch-recs-carousel', PchRecsCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quick-entry-compare"] && !Shopify.designMode) return;
  try {
    class CompareCarousel extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.compare__table');
      this.nav = this.querySelector('.compare__nav');
      if (!this.grid || !this.nav) return;
      this.prev = this.nav.querySelector('[data-dir="-1"]');
      this.next = this.nav.querySelector('[data-dir="1"]');

      const step = () => {
        const card = this.grid.querySelector('.compare-card');
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        return card.offsetWidth + gap;
      };
      const update = () => {
        const max = this.grid.scrollWidth - this.grid.clientWidth - 1;
        this.prev.disabled = this.grid.scrollLeft <= 0;
        this.next.disabled = this.grid.scrollLeft >= max;
      };
      const go = (dir) => {
        const size = step();
        if (!size) return;
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        const target = Math.max(0, Math.min(max, (Math.round(this.grid.scrollLeft / size) + dir) * size));
        this.grid.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(update, 400);
      };

      this.prev.addEventListener('click', () => go(-1));
      this.next.addEventListener('click', () => go(1));
      this.grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(this.grid);
      update();
    }
  }
  if (!customElements.get('compare-carousel')) customElements.define('compare-carousel', CompareCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["winners-carousel"] && !Shopify.designMode) return;
  try {
    // One controller per `.winners__group`: drives its track and shows/hides arrows based on whether
  // the track actually overflows (grid-desktop or ≤3 cards = none; overflowing/mobile = arrows).
  class WinnersGroup {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-cards]');
      const nav = root.querySelector('[data-nav]');
      this.prev = nav && nav.querySelector('[data-dir="-1"]');
      this.next = nav && nav.querySelector('[data-dir="1"]');
      this.update = this.update.bind(this);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      if (this.track) {
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (window.ResizeObserver) new ResizeObserver(this.update).observe(this.track);
      }
      this.update();
    }

    step() {
      const card = this.track.firstElementChild;
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.root.classList.toggle('winners__group--scrollable', max > 0);
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    go(dir) {
      const size = this.step();
      if (!size) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const target = Math.max(0, Math.min(max, (Math.round(this.track.scrollLeft / size) + dir) * size));
      this.track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(() => {
        if (Math.abs(this.track.scrollLeft - target) > 4) this.track.scrollLeft = target;
        this.update();
      }, 300);
      setTimeout(() => this.update(), 700);
    }
  }

  class WinnersCarousel extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.winners__group')).map((g) => new WinnersGroup(g));
      this.onResize = () => this.groups.forEach((g) => g.update());
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }
  }
  if (!customElements.get('winners-carousel')) {
    customElements.define('winners-carousel', WinnersCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["winners-stats"] && !Shopify.designMode) return;
  try {
    (function () {
    // Shared, deduped fetch per endpoint (same registry the winners list uses).
    window.PchWinners = window.PchWinners || {};
    function load(endpoint) {
      window.PchWinners[endpoint] =
        window.PchWinners[endpoint] ||
        fetch(endpoint, { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      return window.PchWinners[endpoint];
    }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmt(n, prefix) {
      return (prefix || '') + Math.round(n).toLocaleString('en-US');
    }

    function appendSuffix(el, text) {
      if (!text) return;
      var s = document.createElement('span');
      s.className = 'pch-stats__suffix';
      s.textContent = text;
      el.appendChild(s);
    }

    // Build an odometer for `finalStr`: a reel (0-9 ×2) per digit, static spans
    // for separators ($ , ). Reels start showing 0; rollOdometer spins them.
    function buildOdometer(el, finalStr) {
      el.textContent = '';
      var reels = [];
      for (var i = 0; i < finalStr.length; i++) {
        var ch = finalStr.charAt(i);
        if (ch >= '0' && ch <= '9') {
          var reel = document.createElement('span');
          reel.className = 'pch-stats__reel';
          var strip = document.createElement('span');
          strip.className = 'pch-stats__reel-strip';
          for (var c = 0; c < 2; c++) {
            for (var d = 0; d <= 9; d++) {
              var cell = document.createElement('span');
              cell.className = 'pch-stats__digit';
              cell.textContent = String(d);
              strip.appendChild(cell);
            }
          }
          reel.appendChild(strip);
          el.appendChild(reel);
          reels.push({ strip: strip, digit: parseInt(ch, 10) });
        } else {
          var sep = document.createElement('span');
          sep.className = 'pch-stats__sep';
          sep.textContent = ch;
          el.appendChild(sep);
        }
      }
      return reels;
    }

    // Roll each reel up to its digit — a full spin (10) plus the digit, in ems so
    // it tracks the responsive font size. Left→right stagger so units settle last.
    function rollOdometer(reels, duration) {
      requestAnimationFrame(function () {
        reels.forEach(function (r, idx) {
          var delay = idx * 60;
          r.strip.style.transition = 'transform ' + duration + 'ms cubic-bezier(0.16, 1, 0.3, 1) ' + delay + 'ms';
          r.strip.style.transform = 'translateY(-' + (10 + r.digit) + 'em)';
        });
      });
    }

    // Fire when the block scrolls into view (fallback: immediately).
    function whenVisible(el, cb) {
      if (!('IntersectionObserver' in window)) {
        cb();
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              io.disconnect();
              cb();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(el);
    }

    function init(el) {
      if (el.dataset.pchInit) return;
      el.dataset.pchInit = '1';

      var endpoint = el.dataset.endpoint || '/apps/winners/stats';
      var duration = parseInt(el.dataset.duration, 10);
      if (isNaN(duration)) duration = 2000;
      var values = el.querySelectorAll('.pch-stats__value');

      // Nothing loads or animates until the block is >25% in view.
      whenVisible(el, function () {
        load(endpoint)
          .then(function (data) {
            if (!data || !data.ok) return;
            var built = [];
            values.forEach(function (v) {
              var target = Number(data[v.dataset.key]);
              if (isNaN(target)) return;
              var finalStr = fmt(target, v.dataset.prefix || '') + (v.dataset.numSuffix || '');
              // Expose the resolved value as a single labelled image so screen readers announce
              // "135+ Millionaire-Making" instead of reading every 0-9 reel digit.
              v.setAttribute('role', 'img');
              v.setAttribute('aria-label', finalStr + (v.dataset.suffix ? ' ' + v.dataset.suffix : ''));
              // Build into a .pch-stats__number wrapper; the loader sits behind it.
              var numberEl = document.createElement('span');
              numberEl.className = 'pch-stats__number';
              if (reduced || duration <= 0) {
                numberEl.textContent = finalStr; // no animation
                appendSuffix(numberEl, v.dataset.suffix);
              } else {
                var reels = buildOdometer(numberEl, finalStr); // renders 0s, ready to roll
                appendSuffix(numberEl, v.dataset.suffix);
                built.push({ v: v, reels: reels });
              }
              // Idempotent: replace any prior number rather than stacking a second
              // one (a re-init, or the foreign app-block script, would otherwise
              // append a duplicate into the same value span).
              var prev = v.querySelector('.pch-stats__number');
              if (prev) prev.remove();
              v.appendChild(numberEl);
              // Safety net: if anything appends another number into this value later,
              // strip the extras so the footer never shows duplicated digits.
              if (window.MutationObserver && !v.dataset.pchGuard) {
                v.dataset.pchGuard = '1';
                new MutationObserver(function () {
                  var nums = v.querySelectorAll('.pch-stats__number');
                  for (var i = 1; i < nums.length; i++) nums[i].remove();
                }).observe(v, { childList: true });
              }
              if (reduced || duration <= 0) built.push({ v: v, reels: null });
            });
            // Paint the number at opacity 0 first, then crossfade in + roll.
            requestAnimationFrame(function () {
              built.forEach(function (b) {
                b.v.classList.add('is-rolling');
                if (b.reels) rollOdometer(b.reels, duration);
              });
            });
          })
          .catch(function () {
            /* leave the values blank on failure */
          });
      });
    }

    function initAll() {
      // Scope to THIS block's own roots. A second odometer (the pch-winners-data app
      // block) also renders .pch-stats; without this both scripts build into each
      // other's element and the numbers duplicate.
      document.querySelectorAll('.pch-stats[data-pch-owner="theme"]').forEach(init);
    }

    // After the page loads, during idle time (doesn't compete with first paint).
    function start() {
      (
        window.requestIdleCallback ||
        function (cb) {
          return setTimeout(cb, 1);
        }
      )(initAll);
    }
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
